const invitationIndex = () => import('@/pages/invitationCommission/index.vue'); // 邀请好友首页
const accountDetail = () => import('@/pages/invitationCommission/accountDetail/index.vue'); // 账户明细
const withdrawDetail = () => import('@/pages/invitationCommission/withdrawDetail/index.vue'); // 提现明细
const subscribe = () => import('@/pages/invitationCommission/subscribe/index.vue'); // 申请提现

const friendTransfer = () => import('@/pages/invitationCommission/friendTransfer/friendTransfer.vue');// 亲友专享优惠中转页

const friendReceive = () => import('@/pages/invitationCommission/friendReceive/friendReceive.vue');// 亲友专享优惠中转页

const friendDetail = () => import('@/pages/invitationCommission/friendDetail/friendDetail.vue');// 好友明细列表

const activeRule = () => import('@/pages/invitationCommission/activeRule/activeRule.vue');// 活动规则

export default [
  {
    path: '/invitation/index',
    component: invitationIndex,
    meta: {
      title: '邀请好友得奖金',
    },
  },
  {
    path: '/invitation/friendTransfer',
    component: friendTransfer,
    meta: {
      title: '亲友专享优惠',
    },
  },
  {
    path: '/invitation/friendReceive',
    component: friendReceive,
    meta: {
      title: '亲友专享优惠',
    },
  },
  {
    path: '/invitation/friendDetail',
    component: friendDetail,
    meta: {
      title: '好友明细',
    },
  },
  {
    path: '/invitation/activeRule',
    component: activeRule,
    meta: {
      title: '活动规则',
    },
  },
  {
    path: '/invitation/accountDetail',
    component: accountDetail,
    meta: {
      title: '账户明细',
    },
  },
  {
    path: '/invitation/withdrawDetail',
    component: withdrawDetail,
    meta: {
      title: '提现明细',
    },
  },
  {
    path: '/invitation/subscribe',
    component: subscribe,
    meta: {
      title: '申请提现',
    },
  },
];
